import { z } from "zod/v4";

import { CustomEventDtoSchema } from "../../../dtos/analytics-events/custom-events";

export const ArchiveCustomEventRequestBodySchema = z.object({
  customEventId: z.uuid(),
});

export type ArchiveCustomEventRequestBodyType = z.infer<
  typeof ArchiveCustomEventRequestBodySchema
>;

export const ArchiveCustomEventResponseBodySchema = z.object({
  customEvent: CustomEventDtoSchema,
});

export type ArchiveCustomEventResponseBodyType = z.infer<
  typeof ArchiveCustomEventResponseBodySchema
>;
